import { css } from '@emotion/react';

export const imageStyles = css`
  flex: 1;
  min-width: 0;
  max-width: 100%;
  aspect-ratio: 1;
  border-radius: var(--spacing-2);
  object-fit: cover;
  border: 1px solid var(--color-neutral-200);
`;
